import { usePathname } from '#app/lib/hooks/router-compat';

import { useWorkspace } from "#app/lib/data/workspace-context";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";

/**
 * Navigation rows that light up for the current route. `isActive` reads the
 * pathname, so every caller SUBSCRIBES to it and re-renders on each
 * navigation — which is the point for a sidebar, and pure cost for anything
 * else. A component that only navigates (a menu row, a rail tile press, a
 * toast action) takes `useAppNavigate().push` directly; `navigate` here is
 * that same function.
 */
export function useSidebarNav() {
  const pathname = usePathname();
  const { push } = useAppNavigate();
  const { activeWorkspace } = useWorkspace();

  const wp = activeWorkspace?.urlPath ?? "";

  const isActive = (route: string, exact?: boolean) => {
    const stripped = wp
      ? pathname.replace(`/${wp}`, "") || "/"
      : pathname;

    if (route === "/") return stripped === "/" || stripped === "";
    if (exact) return stripped === route;
    return stripped === route || stripped.startsWith(`${route}/`);
  };

  return { pathname, navigate: push, isActive };
}
